import React from 'react';
import { SectionHead } from './ui/SectionHead';
import { SectionReveal } from './ui/SectionReveal';
import { credentials, organizations, outcomes } from '../data/record';
export function Record() {
  return <section id="record" className="border-t border-rule py-[clamp(66px,9vw,114px)]" data-id="element-124" data-mp="2febrqirvkxq4">
      <div className="mx-auto max-w-shell px-[clamp(20px,5vw,64px)]" data-id="element-125" data-mp="2kcn0eq6fp26r">
        <SectionHead index="03" kicker="Record" title="Where the experience comes from." intro="Waydev was bootstrapped from 2017 and has been measuring enterprise engineering organizations ever since. The advisory work is a byproduct of that, not a separate practice." data-id="element-126" data-mp="1mq67dx4qhaqt" />

        <div className="mt-12 grid grid-cols-1 gap-[clamp(28px,5vw,72px)] md:grid-cols-2" data-id="element-127" data-mp="21ngopn425aug">
          <SectionReveal data-id="element-128" data-mp="383sjrfbl2clt">
            <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink-45" data-id="element-129" data-mp="382hd97qr6qr0">
              Engineering organizations served
            </p>

            <ul className="mt-5 flex flex-wrap gap-2.5" data-id="element-130" data-mp="phmv09etogr6">
              {organizations.map(org => <li key={org} className="border border-rule px-[13px] py-2 font-mono text-[12px] tracking-[0.05em] text-ink-70" data-id="element-131" data-mp="kj1us9zklx2q">
                  {org}
                </li>)}
            </ul>

            <dl className="mt-8 grid grid-cols-1 border-t border-ink sm:grid-cols-3" data-id="element-132" data-mp="bhu4ae3aq0j7">
              {outcomes.map(outcome => <div key={outcome.label} className="border-b border-rule-soft py-4 pr-3 last:border-b-0 sm:border-b-0" data-id="element-133" data-mp="1skex5zu6vys">
                  <dt className="sr-only" data-id="element-134" data-mp="3swiwulncrgbh">{outcome.label}</dt>
                  <dd data-id="element-135" data-mp="3oy1pc100s3tj">
                    <b className="block font-serif text-[clamp(22px,2.6vw,30px)] font-medium leading-none tracking-[-0.02em]" data-id="element-136" data-mp="3oyuuwyn8sna3">
                      {outcome.value}
                    </b>
                    <span className="mt-2 block max-w-[16ch] font-mono text-[10.5px] uppercase leading-[1.5] tracking-[0.12em] text-ink-45" data-id="element-137" data-mp="3ezccwnqw7bko">
                      {outcome.label}
                    </span>
                  </dd>
                </div>)}
            </dl>

            <p className="mt-5 max-w-[46ch] text-[15px] text-ink-70" data-id="element-138" data-mp="2ve3t0pxp3uo1">
              Reported across Waydev deployments, measured against each
              organization&rsquo;s own pre-engagement baseline.
            </p>

            <figure className="mt-9 max-w-[300px]" data-id="element-139" data-mp="3o2hs790isx16">
              <div className="border border-rule bg-bone-2 p-1.5" data-id="element-140" data-mp="3t1c73zvda1g0">
                <img src="https://cdn.magicpatterns.com/uploads/9oCdhNqN5xVM3pH6rrbHwo/pasted-image.jpg" alt="Alex Circei" className="aspect-[4/5] w-full object-cover contrast-[1.06] saturate-[0.9]" data-id="element-141" data-mp="3t2navzotb974" />
              </div>
              <figcaption className="mt-2.5 font-mono text-[10.5px] uppercase tracking-[0.12em] text-ink-45" data-id="element-142" data-mp="at3c4xoy6jit">
                Alex Circei
                <span className="px-1.5 text-rule" data-id="element-143" data-mp="20bs0m0knt5eu">/</span>
                Co-founder &amp; CEO, Waydev
              </figcaption>
            </figure>
          </SectionReveal>

          <SectionReveal delay={0.06} data-id="element-144" data-mp="2a24w2nu0iizr">
            <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink-45" data-id="element-145" data-mp="2a137dgk2pxzk">
              Recognition
            </p>
            <ul className="mt-5" data-id="element-146" data-mp="253tko8o2k0ff">
              {credentials.map(credential => <li key={credential.source} className="border-t border-rule-soft py-[13px] text-[15px] text-ink-70" data-id="element-147" data-mp="1hdza5xr82nyc">
                  <b className="font-semibold text-ink" data-id="element-148" data-mp="1qedxf2nqyd4h">{credential.source}</b>{' '}
                  {credential.detail}
                </li>)}
            </ul>
          </SectionReveal>
        </div>
      </div>
    </section>;
}